import React from "react";
import { EnrichedProgram } from "@/common/course/types";
import DefaultCarousel from "./DefaultCarousel";
import CenteredCarousel from "./CenteredCarousel";

type CardType = "product-card" | "program-card" | "new-product-card";
type NavigationType = "default" | "individual-buttons";

interface CarouselComponentProps {
  items: EnrichedProgram[];
  getUrl: (path?: string) => string | undefined;
  cardType?: CardType;
  navigationType?: NavigationType;
  isLoading?: boolean;
  isButtonsCentered?: boolean;
  hasShadow?: boolean;
  className?: string;
}

function CarouselComponent({
  items,
  getUrl,
  cardType,
  navigationType = "default",
  isLoading = false,
  isButtonsCentered = false,
  hasShadow = true,
  className = "",
}: CarouselComponentProps) {
  if (isButtonsCentered) {
    return (
      <CenteredCarousel
        items={items}
        getUrl={getUrl}
        cardType={cardType}
        navigationType={navigationType}
        isLoading={isLoading}
        hasShadow={hasShadow}
      />
    );
  }

  return (
    <DefaultCarousel
      items={items}
      getUrl={getUrl}
      cardType={cardType}
      navigationType={navigationType}
      isLoading={isLoading}
      className={className}
    />
  );
}

export default CarouselComponent;
